import { render, staticRenderFns } from "./shares.vue?vue&type=template&id=5ac8721e"
import script from "./shares.vue?vue&type=script&lang=js"
export * from "./shares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports